import React from 'react';
import { useQuery } from '@apollo/client';
import { Alert } from '@mui/material';
import { GET_PATIENT_CREATED_AT } from 'op-components/PatientCard/PatientCardQueries';

// Refer to Jira DA-838 for cutoff date rationale.
const AI_PATIENT_CUTOFF = new Date('2023-09-04T22:00:00.000Z');

interface PreCutoffDisclaimerProps {
  patientId: string;
}

const PreCutoffDisclaimer = ({ patientId }: PreCutoffDisclaimerProps): JSX.Element | null => {
  const { data } = useQuery(GET_PATIENT_CREATED_AT, {
    variables: { patientId },
    fetchPolicy: 'cache-first',
    skip: !patientId,
  });

  const createdAt = data?.patient?.createdAt;
  if (!createdAt || new Date(createdAt) >= AI_PATIENT_CUTOFF) return null;

  return (
    <Alert severity="warning" sx={{ mx: 2, my: 1.5, borderRadius: 2, bgcolor: '#fff3cd' }}>
      For the pilot phase, no data <b>before September 2023</b> was ingested. The AI-generated content does{' '}
      <b>not reflect the full patient history</b>.
    </Alert>
  );
};

export default PreCutoffDisclaimer;
